import axios from 'services/axios'
import { API_NOTIFICATION_LIST } from 'constants/endpoints'

/**
 * Get data list
 * @param {String} url
 * @returns {Object}
 */
export const getListNotification = async () => {
  try {
    const { data } = await axios.get(API_NOTIFICATION_LIST)

    const notifications = []

    data.forEach((group) => {
      group.notifications.forEach((notification) => {
        if (notification.type === 'tag_as_resolved') {
          notification.type = 'ticket-confirm'
        }

        if (notification.type === 'add_new_comment') {
          notification.type = 'ticket-comment'
        }

        if (notification.type === undefined || notification.type === null) {
          notification.type = group.type
        }

        notifications.push(notification)
      })
    })

    return notifications
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Mark all notification is read
 * @returns
 */
export const markReadAll = async () => {
  try {
    await axios.put(API_NOTIFICATION_LIST)
  } catch (error) {
    return Promise.reject(error)
  }
}
